import React, { useEffect } from "react";

const SocketContext = React.createContext(null);

export function SockectProvider({ children, socket }) {
  useEffect(() => {
    if (socket) {
      socket.on("connect", () => {
        console.log("socket connected");
      });

      socket.on("error", (res) => {
        console.log("socket has error", res);
      });

      socket.on("action_result", (res) => {
        console.log("action_result", res);
      });

      if (socket.disconnected) socket.connect();
    }
  });

  return (
    <SocketContext.Provider value={socket}>
      {React.cloneElement(children, { socket: socket })}
    </SocketContext.Provider>
  );
}

export const useSocket = () => React.useContext(SocketContext);
